import CustomLogger from 'common/lib/CustomLogger';

const logger = new CustomLogger({
  label: 'InlineEditor',
  color: 'gold',
  debug: !!window?.Kajabi?.themeBuilder?.debug,
});

export default logger;
